<div id="header" class="wrapper">
  <div class="left">
    <h2>{{title}}</h2>
  </div>  
</div>
<mat-dialog-content class="mat-typography">
    <div class="dialog__content__label" [innerHtml]="message"></div>
</mat-dialog-content>
<mat-dialog-actions>
    <button
        mat-flat-button 
        class="btn-dialog btn-dialog--primary" 
        (click)="close()">Login</button>
</mat-dialog-actions>
